export default __webpack_public_path__ + "static/media/ISMO CLASS-8_SYLLABUS_2025-26.1f9d7169.pdf";